module.exports = __webpack_public_path__ + "static/media/ios-glasses.b3a62b49.svg";